import type { IMethodology } from '__generated__';
import { baseApi, methodologyActiveTag } from 'store/api';
import { APIRead, getAllDynamic, normalizeError } from 'utils/api-client';

export const methodologyApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getActiveMethodologies: builder.query<IMethodology[], void>({
      async queryFn() {
        try {
          const { value } = await getAllDynamic<IMethodology>(
            (body) => APIRead.api.methodologyGetAllDynamicCreate(body),
            {
              filter: 'isActive==true',
              orderBy: 'title asc',
            },
          );

          return { data: value };
        } catch (error) {
          return { error: normalizeError(error) };
        }
      },
      providesTags: [methodologyActiveTag],
    }),
  }),
});

export const { useGetActiveMethodologiesQuery, useLazyGetActiveMethodologiesQuery } =
  methodologyApi;
